import { RightRoute } from '@webapps/reactjs-tech-components';
import { ROUTES_PATH } from 'config/constants';
import ROUTES from 'config/routes';
import { Redirect, Switch } from 'react-router-dom';
import { useAuth } from '@webapps/reactjs-tech-components';

const PrivateApp = () => {

  const { profile } = useAuth();

  return (
    <Switch>
      {ROUTES.map(({ accesses, component: Component, exact, path, auth }) => {
        if (!auth) {
          return (
            <RightRoute
              key={path}
              exact={exact}
              path={path}
              rights={accesses}
              routeRedirection={ROUTES_PATH.NOT_FOUND}
            >
              <Component />
            </RightRoute>
          );
        }
        return null;
      })}
      {profile === 'BUSINESS' && (
        <Redirect from="*" to={ROUTES_PATH.BUSINESS_DASHBOARD} />
      )}
      {profile === 'SCHOOL' && (
        <Redirect from="*" to={ROUTES_PATH.SCHOOL_DASHBOARD} />
      )}
      {profile === 'INDIVIDUAL' && (
        <Redirect from="*" to={ROUTES_PATH.STUDENT_DASHBOARD} />
      )}
      {profile === 'CFA' && (
        <Redirect from="*" to={ROUTES_PATH.CFA_DASHBOARD} />
      )}
    </Switch>
  );
}

export default PrivateApp;
